import { Injectable, Inject } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { WebStorageService, LOCAL_STORAGE } from 'ngx-webstorage-service';
import { AESEncrypt } from 'src/app/common/Helper/AESEncryp';

@Injectable({
	providedIn: 'root',
})

export class CatalogosService {
	
	endpoint = environment.apiUrl + 'Catalogos/';
	aes = new AESEncrypt();

	// endpoint = 'https://localhost:5205/';

	constructor(
		private http: HttpClient,
		@Inject(LOCAL_STORAGE)
		private storage: WebStorageService
	) { }

	buscarCatalogo(catalog): Observable<any> {
		let resultado = this.http.get(`${this.endpoint}${catalog}`);
		return resultado;
	}

	setTipoActividad() {
		this.buscarCatalogo('tipoActividad').subscribe((response) => {
			this.storage.set(
				'tipoActividad', 
				this.aes.encryptModel(response.data.info.result)
			);
		});
	}

	getTipoActividad() {
		return  this.aes.decryptModel(this.storage.get('tipoActividad'));
	}

	setPersonallidadFiscal() {
		this.buscarCatalogo('personalidadfiscal').subscribe((response) => {
			this.storage.set(
				'personalidadFiscal', 
				this.aes.encryptModel(response.data.info.result)
			);
		});
	}

	getPersonalidadFiscal() {
		return this.aes.decryptModel(this.storage.get('personalidadFiscal'));
	}

	setEstatus() {
		this.buscarCatalogo('estatus').subscribe((response) => {
			this.storage.set(
				'estatus', 
				this.aes.encryptModel(response.data.info.result)
			);
		});
	}

	getEstatus() {
		return  this.aes.decryptModel(this.storage.get('estatus'));
	}

	setPais() {
		this.buscarCatalogo('pais').subscribe((response) => {
			this.storage.set(
				'pais', 
				this.aes.encryptModel(response.data.info.result)
			);
		});
	}

	getPais() {
		return this.aes.decryptModel(this.storage.get('pais'));
	}

	getEstado(paisId: number) {
		let estados: [];
		this.buscarCatalogo('estado/pais/' + paisId).subscribe((response) => {
			estados = response.data.info.result;
		});
		return estados;
	}

	setSexo() {
		this.buscarCatalogo('sexo').subscribe((response) => {
			this.storage.set(
				'sexo', 
				this.aes.encryptModel(response.data.info.result)
			);
		});
	}

	getSexo() {
		return this.aes.decryptModel(this.storage.get('sexo'));
	}

	setParametroAlerta() {
		this.buscarCatalogo('parametroAlerta').subscribe((response) => {
			this.storage.set(
				'parametroAlerta', 
				this.aes.encryptModel(response.data.info.result)
			);
		});
	}
	
	getParametroAlerta() {
		let resp = this.storage.get('parametroAlerta');
		return this.aes.decryptModel(resp);
	}

	setEstadoCivil() {
		this.buscarCatalogo('estadocivil').subscribe((response) => {
			this.storage.set(
				'estadocivil', 
				this.aes.encryptModel(response.data.info.result)
			);
		});
	}

	getEstadoCivil() {
		return this.aes.decryptModel(this.storage.get('estadocivil'));
	}

	setTipoEmpleado() {
		this.buscarCatalogo('TipoEmpleoad').subscribe((response) => {
			this.storage.set('TipoEmpleoad', response.data.info.result);
		});
	}

	getTipoEmpleado() {
		return this.storage.get('TipoEmpleoad');
	}

	setSucursal() {
		this.buscarCatalogo('sucursal').subscribe((response) => {
			this.storage.set(
				'sucursal', 
				this.aes.encryptModel(response.data.info.result)
			);
		});
	}

	getSucursal() {
		return this.aes.decryptModel(this.storage.get('sucursal'));
	}

	setActividadEconomica() {
		this.buscarCatalogo('actividadeconomica').subscribe((response) => {
			this.storage.set(
				'actividadeconomica', 
				this.aes.encryptModel(response.data.info.result)
			);
		});
	}

	getActividadEconomica() {
		return this.aes.decryptModel(this.storage.get('actividadeconomica'));
	}

	setIngresoMensual() {
		this.buscarCatalogo('ingresomensual').subscribe((response) => {
			this.storage.set(
				'ingresomensual', 
				this.aes.encryptModel(response.data.info.result)
			);
		});
	}

	getIngresoMensual() {
		return this.aes.decryptModel(this.storage.get('ingresomensual'));
	}

	setAntiguedad() {
		this.buscarCatalogo('antiguedad').subscribe((response) => {
			this.storage.set(
				'antiguedad', 
				this.aes.encryptModel(response.data.info.result)
			);
		});
	}

	getAntiguedad() {
		return this.aes.decryptModel(this.storage.get('antiguedad'));
	}

	setArea() {
		this.buscarCatalogo('area').subscribe((response) => {
			this.storage.set(
				'area', 
				this.aes.encryptModel(response.data.info.result)
			);
		});
	}

	getArea() {
		return this.aes.decryptModel(this.storage.get('area'));
	}

	setContratacion() {
		this.buscarCatalogo('contratacion').subscribe((response) => {
			this.storage.set(
				'contratacion', 
				this.aes.encryptModel(response.data.info.result)
			);
		});
	}

	getContratacion() {
		return this.aes.decryptModel(this.storage.get('contratacion'));
	}

	setTipoLista() {
		this.buscarCatalogo('listanegratipo').subscribe((response) => {
			this.storage.set(
				'listanegratipo', 
				this.aes.encryptModel(response.data.info.result)
			);
		});
	}

	getTipoLista() {
		return this.aes.decryptModel(this.storage.get('listanegratipo'));
	}

	setAlerta() {
		if (this.getAlerta() !== null) {
			this.storage.remove('alerta');
		}
		this.buscarCatalogo('alerta').subscribe((response) => {
			this.storage.set(
				'alerta', 
				this.aes.encryptModel(response.data.info.result)
			);
		});
	}

	getAlerta() {
		let resultado = this.storage.get('alerta');
		return this.aes.decryptModel(resultado);
	}


	setActividades() {
		if (this.getActividades() !== null) {
			this.storage.remove('alertaAV');
		}
		this.buscarCatalogo('alertaAV').subscribe((response) => {
			this.storage.set(
				'alertaAV', 
				this.aes.encryptModel(response.data.info.result)
			);
		});
	}

	getActividades() {
		let resultado = this.storage.get('alertaAV');
		return this.aes.decryptModel(resultado);
	}

	setReportes() {
		if (this.getReportes() !== null) {
			this.storage.remove('reportesRegulatorios');
		}
		this.buscarCatalogo('reportesRegulatorios').subscribe((response) => {
			this.storage.set(
				'reportesRegulatorios', 
				this.aes.encryptModel(response.data.info.result)
			);
		});
	}

	getReportes() {
		let resultado = this.storage.get('reportesRegulatorios');
		return this.aes.decryptModel(resultado);
	}

	cargarRol(): Observable<any> {
		return this.http.get<any>(
			`${this.endpoint}rol/rolesHabilitados`
		);
	}

	setRol() {
		this.buscarCatalogo('rol').subscribe((response) => {
			this.storage.set(
				'rol', 
				this.aes.encryptModel(response.data.info.result)
			);
		});
	}

	getRol() {
		return this.aes.decryptModel(this.storage.get('rol'));
	}

	setRiesgo() {
  	  this.buscarCatalogo('riesgo').subscribe(response => {
  	    const resultadosFiltrados = response.data.info.result.filter(item => item['riesgoId'] < 30);
  	    const riesgoCompleto = response.data.info.result;
  	    riesgoCompleto.sort((a, b) => a.riesgoId - b.riesgoId);
  	    resultadosFiltrados.sort((a, b) => a.riesgoId - b.riesgoId);
		this.storage.set(
				'riesgo', 
				this.aes.encryptModel(resultadosFiltrados)
		);
		this.storage.set(
				'riesgoComplete', 
				this.aes.encryptModel(riesgoCompleto)
		);
  	  });
  	}

	getRiesgo() {
		return this.aes.decryptModel(this.storage.get('riesgo'));
	}

	getRiesgoComplete() {
  	  return this.aes.decryptModel(this.storage.get('riesgoComplete'));
  	}

	setProbabilidad() {
		this.buscarCatalogo('probabilidad').subscribe(response => {
			this.storage.set(
				'probabilidad',
				this.aes.encryptModel(response.data.info.result)
			);
		});
	}

	getProbabilidad() {
		return this.aes.decryptModel(this.storage.get('probabilidad'));
	}

	setPuesto() {
		this.buscarCatalogo('puesto').subscribe((response) => {
			this.storage.set(
				'puesto', 
				this.aes.encryptModel(response.data.info.result)
			);
		});
	}

	getPuesto() {
		return this.aes.decryptModel(this.storage.get('puesto'));
	}

	setDomicilioTipo() {
		this.buscarCatalogo('domiciliotipo').subscribe((response) => {
			this.storage.set(
				'domicilioTipo', 
				this.aes.encryptModel(response.data.info.result)
			);
		});
	}

	getDomicilioTipo() {
		return this.aes.decryptModel(this.storage.get('domicilioTipo'));
	}

	setViviendaTipo() {
		this.buscarCatalogo('viviendatipo').subscribe((response) => {
			this.storage.set(
				'viviendaTipo', 
				this.aes.encryptModel(response.data.info.result)
			);
		});
	}

	getViviendaTipo() {
		return this.aes.decryptModel(this.storage.get('viviendaTipo'));
	}

	setCodigoPostal() {
		this.buscarCatalogo('codigopostal').subscribe((response) => {
			this.storage.set('codigopostal', response.data.info.result);
		});
	}

	getCodigoPostal() {
		return this.storage.get('codigopostal');
	}

	setMedioContacto() {
		this.buscarCatalogo('mediocontacto').subscribe((response) => {
			this.storage.set(
				'mediocontacto', 
				this.aes.encryptModel(response.data.info.result)
			);
		});
	}

	getMedioContacto() {
		return this.aes.decryptModel(this.storage.get('mediocontacto'));
	}

	setParentesco() {
		this.buscarCatalogo('parentesco').subscribe((response) => {
			this.storage.set(
				'parentesco', 
				this.aes.encryptModel(response.data.info.result)
			);
		});
	}

	getParentesco() {
		return this.aes.decryptModel(this.storage.get('parentesco'));
	}

	setTipoDocumentacion() {
		this.buscarCatalogo('documentacion').subscribe((response) => {
			this.storage.set(
				'documentacion', 
				this.aes.encryptModel(response.data.info.result)
			);
		});
	}

	getTipoDocumentacion() {
		return this.aes.decryptModel(this.storage.get('documentacion'));
	}

	setEscolaridad() {
		this.buscarCatalogo('escolaridad').subscribe((response) => {
			this.storage.set(
				'escolaridad', 
				this.aes.encryptModel(response.data.info.result)
			);
		});
	}

	getEscolaridad() {
		return this.aes.decryptModel(this.storage.get('escolaridad'));
	}

	setModulo() {
		this.buscarCatalogo('modulo').subscribe((response) => {
			this.storage.set(
				'modulo', 
				this.aes.encryptModel(response.data.info.result)
			);
		});
	}

	getModulo() {
		return this.aes.decryptModel(this.storage.get('modulo'));
	}

	setIdioma() {
		this.buscarCatalogo('idioma').subscribe((response) => {
			this.storage.set(
				'idioma', 
				this.aes.encryptModel(response.data.info.result)
			);
		});
	}

	getIdioma() {
		return this.aes.decryptModel(this.storage.get('idioma'));
	}

	setDivisa() {
		this.buscarCatalogo('divisa').subscribe((response) => {
			this.storage.set(
				'divisa', 
				this.aes.encryptModel(response.data.info.result)
			);
		});
	}

	getDivisa() {
		return this.aes.decryptModel(this.storage.get('divisa'));
	}

	setInstrumento() {
		this.buscarCatalogo('instrumento').subscribe((response) => {
			this.storage.set(
				'instrumento', 
				this.aes.encryptModel(response.data.info.result)
			);
		});
	}

	getInstrumento() {
		return this.aes.decryptModel(this.storage.get('instrumento'));
	}

	setTipoOperacion() {
		this.buscarCatalogo('tipoOperacion').subscribe((response) => {
			this.storage.set(
				'tipoOperacion', 
				this.aes.encryptModel(response.data.info.result)
			);
		});
	}

	getTipoOperacion() {
		return this.aes.decryptModel(this.storage.get('tipoOperacion'));
	}

	setFuenteIngreso() {
		this.buscarCatalogo('fuenteingresos').subscribe((response) => {
			this.storage.set(
				'fuenteingresos', 
				this.aes.encryptModel(response.data.info.result)
			);
		});
	}

	getFuenteIngreso() {
		return this.aes.decryptModel(this.storage.get('fuenteingresos'));
	}

	setDestinoRecursos() {
		this.buscarCatalogo('destinorecurso').subscribe((response) => {
			this.storage.set(
				'destinorecurso', 
				this.aes.encryptModel(response.data.info.result)
			);
		});
	}

	getDestinoRecursos() {
		return this.aes.decryptModel(this.storage.get('destinorecurso'));
	}

	setTipoReporte() {
		this.buscarCatalogo('TipoReporte').subscribe((Response) => {
			this.storage.set(
				'tipoReporte', 
				this.aes.encryptModel(Response.data.info.result)
			);
		});
	}

	getTipoReporte() {
		let result = this.storage.get('tipoReporte');
		return this.aes.decryptModel(result);
	}

	setOrigenRecursos() {
		this.buscarCatalogo('origenrecurso').subscribe((response) => {
			this.storage.set(
				'origenrecurso', 
				this.aes.encryptModel(response.data.info.result)
			);
		});
	}

	getOrigenRecursos() {
		return this.aes.decryptModel(this.storage.get('origenrecurso'));
	}

	setPeriodicidad() {
		this.buscarCatalogo('periodicidad').subscribe((response) => {
			this.storage.set(
				'periodicidad', 
				this.aes.encryptModel(response.data.info.result)
			);
		});
	}

	getPeriodicidad() {
		return this.aes.decryptModel(this.storage.get('periodicidad'));
	}

	getPersonalidadFiscalFiltro() {
		return this.aes.decryptModel(this.storage.get('personalidadFiscal'));
	}

	setPersonalidadFiscalFiltro() {
		this.buscarCatalogo('personalidadFiscalFiltro').subscribe((response) => {
			this.storage.set('personalidadFiscalFiltro', response.data.info.result);
		});
	}

	setSucursalRango() {
		this.buscarCatalogo('sucursalRango').subscribe((response) => {
			this.storage.set(
				'sucursalRango', 
				this.aes.encryptModel(response.data.info.result)
			);
		});
	}

	getSucursalRango() {
		return this.aes.decryptModel(this.storage.get('sucursalRango'));
	}

	setTipoCobertura() {
		this.buscarCatalogo('tipoCobertura').subscribe((response) => {
			this.storage.set(
				'tipoCobertura', 
				this.aes.encryptModel(response.data.info.result)
			);
		});
	}

	getTipoCobertura() {
		return this.aes.decryptModel(this.storage.get('tipoCobertura'));
	}

	setEmpleadoRango() {
		this.buscarCatalogo('empleadoRango').subscribe((response) => {
			this.storage.set(
				'empleadoRango', 
				this.aes.encryptModel(response.data.info.result)
			);
		});
	}

	getEmpleadoRango() {
		return this.aes.decryptModel(this.storage.get('empleadoRango'));
	}

	getGenericCatalog(objParametro: any): Observable<any> {
		return this.http.post<any>(
			this.endpoint + 'parametro/buscarCatalogoGenerico',
			JSON.stringify(objParametro)
		);
	}

	setParametros() {
		this.buscarCatalogo('parametro').subscribe(response => {
			this.storage.set(
				'parametros', 
				this.aes.encryptModel(response.data.info.result)
			);
		});
	}

	getParametros() {
		return this.aes.decryptModel(this.storage.get('parametros'));
	}

	setPonderador() {
		this.buscarCatalogo('ponderador').subscribe(response => {
			this.storage.set(
				'ponderador', 
				this.aes.encryptModel(response.data.info.result)
			);
		});
	}

	getPonderador() {
		return this.aes.decryptModel(this.storage.get('ponderador'));
	}

	getAlertaPOM(buscar: any): Observable<any> {
		return this.http.post<any>(
			this.endpoint + 'ParametroOpcionMultiple/opcionMultiple',
			JSON.stringify(buscar)
		);
	}

	setParametrosOpcionMultiple() {
		this.buscarCatalogo('parametroopcionmultiple').subscribe(response => {
			this.storage.set(
				'parametroopcionmultiple', 
				this.aes.encryptModel(response.data.info.result)
			);
		});
	}

	getParametrosOpcionMultiple() {
		return this.aes.decryptModel(this.storage.get('parametroopcionmultiple'));
	}

	limpiarCatalogos(cargar) {
		if (this.getPersonalidadFiscal() !== null) {
			this.storage.remove('personalidadFiscal');
		}
		if (this.getEstatus() !== null) {
			this.storage.remove('estatus');
		}
		if (this.getPais() !== null) {
			this.storage.remove('pais');
		}
		if (this.getSexo() !== null) {
			this.storage.remove('sexo');
		}
		if (this.getEstadoCivil() !== null) {
			this.storage.remove('estadocivil');
		}
		if (this.getSucursal() !== null) {
			this.storage.remove('sucursal');
		}
		if (this.getActividadEconomica() !== null) {
			this.storage.remove('actividadeconomica');
		}
		if (this.getIngresoMensual() !== null) {
			this.storage.remove('ingresomensual');
		}
		if (this.getAntiguedad() !== null) {
			this.storage.remove('antiguedad');
		}
		if (this.getArea() !== null) {
			this.storage.remove('area');
		}
		if (this.getContratacion() !== null) {
			this.storage.remove('contratacion');
		}
		if (this.getTipoLista() !== null) {
			this.storage.remove('listanegratipo');
		}
		if (this.getAlerta() !== null) {
			this.storage.remove('alerta');
		}
		if (this.getActividades() !== null) {
			this.storage.remove('alertaAV');
		}
		if (this.getReportes() !== null) {
			this.storage.remove('reportesRegulatorios');
		}
		if (this.getRol() !== null) {
			this.storage.remove('rol');
		}
		if (this.getRiesgo() !== null) {
			this.storage.remove('riesgo');
		}
		if (this.getProbabilidad() !== null) {
			this.storage.remove('probabilidad');
		}
		if (this.getPuesto() !== null) {
			this.storage.remove('puesto');
		}
		if (this.getDomicilioTipo() !== null) {
			this.storage.remove('domicilioTipo');
		}
		if (this.getViviendaTipo() !== null) {
			this.storage.remove('viviendaTipo');
		}
		if (this.getMedioContacto() !== null) {
			this.storage.remove('mediocontacto');
		}
		if (this.getParentesco() !== null) {
			this.storage.remove('parentesco');
		}
		if (this.getTipoDocumentacion() !== null) {
			this.storage.remove('documentacion');
		}
		if (this.getModulo() !== null) {
			this.storage.remove('modulo');
		}
		if (this.getTipoOperacion() !== null) {
			this.storage.remove('tipoOperacion');
		}
		if (this.getDivisa() !== null) {
			this.storage.remove('divisa');
		}
		if (this.getInstrumento() !== null) {
			this.storage.remove('instrumento');
		}
		if (this.getFuenteIngreso() !== null) {
			this.storage.remove('fuenteingresos');
		}
		if (this.getDestinoRecursos() !== null) {
			this.storage.remove('destinorecurso');
		}
		if (this.getOrigenRecursos() !== null) {
			this.storage.remove('origenrecurso')
		}
		if (this.getParametroAlerta() != null) {
			this.storage.remove('parametroAlerta');
		}
		if (this.getParametros() != null) {
			this.storage.remove('parametros');
		}
		if (this.getPonderador() !== null) {
			this.storage.remove('ponderador');
		}
		if (this.getParametrosOpcionMultiple() != null) {
			this.storage.remove('parametroopcionmultiple');
		}
		if (cargar) {
			this.cargarCatalogos();
		}
	}

	cargarCatalogos() {
		this.setPersonallidadFiscal();
		this.setEstatus();
		this.setPais();
		this.setSexo();
		this.setEstadoCivil();
		this.setSucursal();
		this.setActividadEconomica();
		this.setIngresoMensual();
		this.setAntiguedad();
		this.setArea();
		this.setContratacion();
		this.setTipoLista();
		this.setAlerta();
		this.setActividades();
		this.setReportes();
		this.setRol();
		this.setRiesgo();
		this.setProbabilidad();
		this.setPuesto();
		this.setDomicilioTipo();
		this.setViviendaTipo();
		this.setMedioContacto();
		this.setParentesco();
		this.setTipoDocumentacion();
		this.setEscolaridad();
		this.setModulo();
		this.setIdioma();
		this.setDivisa();
		this.setInstrumento();
		this.setTipoOperacion();
		this.setDestinoRecursos();
		this.setOrigenRecursos();
		this.setFuenteIngreso();
		this.setParametroAlerta();
		this.setParametros();
		this.setPonderador();
		this.setTipoEmpleado();
		this.setParametrosOpcionMultiple();
	}
}
